import { React, useState, useEffect } from "react";
import { Container, useMediaQuery, styled, useTheme } from "@mui/material";
import maxAvatar from "../assets/headshot.jpeg";
import {
  Loader,
  Navbar,
  SideAnchorLinks,
  Hero,
  About,
  Experience,
  Projects,
  Hobbies,
  Footer,
} from "../components";

const StyledMainPage = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  overflow: "hidden",
}));
const StyledMainContainer = styled(Container)({
  maxWidth: "1600px",
});

const Main = () => {
  const theme = useTheme();
  const showSideAnchor = useMediaQuery(theme.breakpoints.up("lg"));
  const [isLoading, setIsloading] = useState(true);
  const [heroImg, setHeroImg] = useState(null);

  //Loader animation before rest of the page gets rendered
  useEffect(() => {
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      setIsloading(false);
      document.body.style.overflow = "";
    }, 3250);

    const loadImage = async () => {
      const img = new Image();
      img.src = maxAvatar;
      await img.decode();
      setHeroImg(maxAvatar);
    };
    loadImage();
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: theme.palette.background.main,
          zIndex: -1,
        }}
      />
      <div
        style={{
          opacity: isLoading ? 0 : 1,
          transition: isLoading ? "none" : "opacity 0.4s ease-in",
        }}
      >
        <Navbar />
        <StyledMainPage>
          {showSideAnchor && <SideAnchorLinks />}
          <StyledMainContainer>
            <Hero img={heroImg} />
            <About />
            <Experience />
            <Projects />
            <Hobbies />
            <Footer />
          </StyledMainContainer>
        </StyledMainPage>
      </div>
    </>
  );
};

export default Main;
